import { CasEntityRHFSelect, CasEntitySelectProps } from 'src/compass/shared/components';

export function CasRHFSharepointSiteSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect('SharepointSite', props);
}
